import { render, staticRenderFns } from "./DesktopPreview.vue?vue&type=template&id=1c428d30&scoped=true&"
import script from "./DesktopPreview.vue?vue&type=script&lang=js&"
export * from "./DesktopPreview.vue?vue&type=script&lang=js&"
import style0 from "./DesktopPreview.vue?vue&type=style&index=0&id=1c428d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c428d30",
  null
  
)

export default component.exports